import React from "react";
import { Formik, ErrorMessage } from "formik";
import {
	add,
	wardQuestion,
	photo,
	name,
	establishedYearQn,
	amountQn,
	remarks,
	source,
	ward,
	selectedLanguage,
} from "../data/institute";
import ImageUploader from "../components/ImageUploader";
import FormFooterButtons from "../components/FormFooterButtons";
import { Card } from "react-bootstrap";
import { GetUUID } from "../data/helpers/RandomNumGenerator";

const initData = {
	ward: "",
	name: "",
	remarks: "",
	amount: "",
	establishedYear: "",
	source: "",
	uniqueIdentifier: GetUUID(),
};

const EconomicResource = (props) => (
	<div>
		<Formik
			enableReinitialize
			initialValues={props.data ? props.data : initData}
			validate={(values) => {
				const errors = {};
				// if (!values.ward) {
				//     errors.ward = 'Required';
				// }
				// if (!values.riskArea) {
				//     errors.riskArea = 'Required';
				// }
				// if (!values.address) {
				//     errors.address = 'Required';
				// }
				// if (!values.effectFromDisasters) {
				//     errors.effectFromDisasters = 'Required';
				// }
				// else
				// if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
				// 	errors.email = "Invalid email address";
				// }
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				console.log(values);
				setTimeout(() => {
					props.submit(values);
					setSubmitting(false);
				}, 400);
			}}
		>
			{({
				values,
				touched,
				errors,
				dirty,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				handleReset,
			}) => (
				<>
					<form className="form survey-form" onSubmit={handleSubmit}>
						<Card>
							<Card.Body>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{wardQuestion[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="ward"
											name="ward"
											onChange={handleChange}
											value={values.ward ? values.ward : "selectOne"}
										>
											<option value="selectOne" disabled>
												कुनै एक छान्नुहोस्
											</option>
											{ward.map((woda) => (
												<option value={woda.value}>
													{woda[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ward"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{name[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={name[selectedLanguage]}
											name="name"
											onChange={handleChange}
											value={values.name}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="name"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{establishedYearQn[selectedLanguage]}
										</label>
										<input
											type="date"
											className="form-control"
											id="example-date-input"
											placeholder={establishedYearQn[selectedLanguage]}
											name="establishedAt"
											onChange={handleChange}
											value={values.establishedAt}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="establishedAt"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{amountQn[selectedLanguage]}
										</label>
										<input
											type="number"
											className="form-control"
											placeholder={amountQn[selectedLanguage]}
											name="amount"
											onChange={handleChange}
											value={values.amount}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="amount"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{source[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={source[selectedLanguage]}
											name="source"
											onChange={handleChange}
											value={values.source}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="source"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{remarks[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={remarks[selectedLanguage]}
											name="remarks"
											onChange={handleChange}
											value={values.remarks}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="remarks"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label>{photo[selectedLanguage]}</label>
										<ImageUploader fileListContent={props.fileListContent} />
									</div>
								</div>

								<div className="card-footer text-right">
									<FormFooterButtons />
								</div>
							</Card.Body>
						</Card>
					</form>
				</>
			)}
		</Formik>
	</div>
);

export default EconomicResource;
